var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-audit-log"},[_c('h4',{staticClass:"mt-2 mb-2"},[_vm._v(" "+_vm._s(_vm.$t('audit_log') + ' (' + _vm.auditLogs.length + ')')+" "),_c('small',[_vm._v("(max. 100 Einträge innerhalb der letzten 14 Tage)")])]),_c('AuditLogs',{attrs:{"auditLogs":_vm.auditLogs,"user":_vm.getCurrentUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }